import React, { Component } from 'react'
//import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditAttendanceReady} from '../redux/attendances'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'




import DateTimeField from "react-bootstrap-datetimepicker";
import {Cities,EntityType,WorkLocations,Kitchens,Departments,Reasons} from '../../../common/DropDowns/index'




import * as Helpers from '../../../common/helpers'

function filterUnwantedData(attendancesData) {
    let array = []
    if (attendancesData && attendancesData.data && attendancesData.data.employees) {
        array = attendancesData.data.employees
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.employee_name = lineData.name ? lineData.name : ""
            newLineData.employee_code = lineData.code ? lineData.code : ""
            newLineData.employee_mobile = lineData.mobile ? lineData.mobile : ""  

            newLineData.attendance_flag=true;
            if(lineData.attendances.length>0){
                newLineData.entered_attendance_type=lineData.attendances[0] && lineData.attendances[0].type ? lineData.attendances[0].type : ""
                newLineData.attendance_flag=false;
            }

            newLineData.work_station=lineData.working_kitchen && lineData.working_kitchen.work_station && lineData.working_kitchen.work_station.name ? lineData.working_kitchen.work_station.name : null

            newLineData.type=""
            newLineData.checkbox=true

            newArray[i] = newLineData
        }
    }
    return newArray
}



function filterUnwantedDataForCorp(attendancesData) {
    let array = []
    if (attendancesData && attendancesData.data && attendancesData.data.list) {
        array = attendancesData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.employee_name = lineData.name ? lineData.name : ""
            newLineData.employee_code = lineData.code ? lineData.code : ""
            newLineData.employee_mobile = lineData.mobile ? lineData.mobile : ""  

            newLineData.attendance_flag=true;
            if(lineData.attendances.length>0){
                newLineData.entered_attendance_type=lineData.attendances[0] && lineData.attendances[0].type ? lineData.attendances[0].type : ""
                newLineData.attendance_flag=false;
            }
            newLineData.work_station=null

            newLineData.type=""
            newLineData.checkbox=true

            newArray[i] = newLineData
        }
    }
    return newArray
}

class AddEditAttendance extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",
        tableHeight:"0px",
        editFlag:false,
        bulkTypeId:"",
        reasonId:"",
        remarks:"",
        departmentId:"",
        kitchen_staff:false,
        attendancesDataFlag:false,
        attendanceDate:Helpers.getDateFormatForUTC(new Date()),

        attendancesData:[],

        cityId: "",
        workLocationType:"",
        workLocationId:"",


        subTitle: Constants.ADD_ATTENDANCE,

        remarksErrorText: false,
            remarksErrorData: '',

            reasonIdErrorText: false,
            reasonIdErrorData: '',

    }

    this.isComponentStillMounted = true

     this.remarksComponent = null
        this.remarksSection = null

        this.reasonIdComponent = null
        this.reasonIdSection = null


    }

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEditAttendanceReady(false))

    if (this.props.attendances && this.props.attendances.attendanceSelectedId && this.props.attendances.attendanceSelectedId !== null) {
        this.props.dispatch(headerDataUpdate(Constants.EDIT_ATTENDANCE))
        this.setState({
            subTitle: "Update Attendance",
            editFlag:true
        })
    } else {
        if(this.props.user.roles[0].includes("Kitchen Manager") || this.props.user.roles[0].includes("Shift Manager")){
            this.setState({
                kitchen_staff:true 
            });
        }

        this.props.dispatch(headerDataUpdate(Constants.ADD_ATTENDANCE))
        this.setState({
            subTitle: "Mark Attendance"
        })
    }
    this.props.dispatch(subHeaderDataUpdate())

    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()


    this.props.dispatch(addEditAttendanceReady(true))


    // if (this.props.attendances && this.props.attendances.attendanceSelectedId && this.props.attendances.attendanceSelectedId !== null) {
    //     this.getTeamAttendanceByKitchenId(this.props.attendances.attendanceSelectedId)
    // }else{

    // this.props.dispatch(addEditAttendanceReady(true))
    // }
}

componentDidMount() {


}


    attendanceDateChange = (newDate) => {

        let attendanceDate=Helpers.getDateFormatForUTC(parseInt(newDate,10));

       

        this.setState({
            attendanceDate: attendanceDate
        },() => {

            if(!Helpers.isItValidForMarkingAttendance(attendanceDate)){
                this.dialog.show({
                            title: "Error!!",
                            body: "You can mark attendance only for current attendance cycle",
                            actions: [
                                Dialog.OKAction(() => {
                                    let attendanceDate=Helpers.getDateFormatForUTC(new Date());
                                    this.setState({
                                        attendanceDate:attendanceDate
                                    });
                                })
                            ],
                        })
        }else if(attendanceDate>Helpers.getDateFormatForUTC(new Date())){
             this.dialog.show({
                            title: "Error!!",
                            body: "You can mark attendance for future dates",
                            actions: [
                                Dialog.OKAction(() => {
                                    let attendanceDate=Helpers.getDateFormatForUTC(new Date());
                                    this.setState({
                                        attendanceDate:attendanceDate
                                    });
                                })
                            ],
                        })
        }

         if(this.state.workLocationId && this.state.workLocationId!=="undefined" && this.state.workLocationId!==""){
            if(this.state.workLocationType!=="Kitchen"){
                if(this.state.departmentId!=="undefined" && this.state.departmentId!==""){
                this.props.dispatch(addEditAttendanceReady(false))
                    this.getTeamAttendanceByWorkLocationId()
                }

            }else{
                this.props.dispatch(addEditAttendanceReady(false))
                this.getTeamAttendanceByKitchenId(this.state.workLocationId)
            }
        }




        });

        
    }

 

    createCustomToolBar = props => {

        return (
            <div className="row mark-attendance-class" style={{ marginLeft: "10px", marginRight: "10px" }}>

             {(() => {
                if(this.state.kitchen_staff){
                        return (
                             <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-div-margins">
                                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                                      <Kitchens kitchenChange={this.kitchenChange} selectedValue={this.state.workLocationId} />
                                    </div>
                             </div>
                        )
                    }else{
                        
                        return(
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-div-margins">
                
                 {(() => {
                    if(Helpers.checkPrivileges("/dashboard/attendances/update",this.props.user)){
                  
                   return(  <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <DateTimeField mode="date" inputFormat="DD-MM-YYYY" dateTime={new Date(this.state.attendanceDate)} onChange={this.attendanceDateChange}/>
                    </div>
                    )
                    }
                })()}


                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <Cities cityChange={this.cityChange} selectedValue={this.state.cityId} />
                    </div>

                    {(() => {
                         if(this.state.cityId && this.state.cityId!=="" && this.state.cityId!==undefined){
                         return (
                     <div className="col-md-2 col-sm-12 col-xs-12 div-margins">

                    <EntityType entityTypeChange={this.workLocationTypeChange} selectedValue={this.state.workLocationType} type="WORK_LOCATIONS" />

                    </div>

                    )
                         }
                         })()}

                      {(() => {
                         if(this.state.workLocationType!=="Kitchen" && this.state.workLocationType && this.state.workLocationType!=="" && this.state.workLocationType!==undefined){
                         return (
                            <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                                 <WorkLocations type={this.state.workLocationType} city_id={this.state.cityId} workLocationChange={this.workLocationChange} selectedValue={this.state.workLocationId} />
                            </div>

                          )
                         }
                         if(this.state.workLocationType==="Kitchen" && this.state.workLocationType && this.state.workLocationType!=="" && this.state.workLocationType!==undefined){
                         return (
                             <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                                 <Kitchens selectedCity={this.state.cityId} kitchenChange={this.kitchenChange} selectedValue={this.state.workLocationId} />
                            </div>
                         )
                         }
                         })()}


                             {(() => {
                         if(this.state.workLocationType!=="Kitchen" && this.state.workLocationId && this.state.workLocationId!=="" && this.state.workLocationId!==undefined){
                         return (

                             <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                                    <Departments departmentChange={this.departmentChange} selectedValue={this.state.departmentId} />

                              </div>

                               )
                         }
                         })()}

                   
                </div> 
                        )
                    }

                })()}

                
            </div>
        )
    }

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
            tableHeight: (window.innerHeight - 275) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {
    
    let data = {}

    data.attendance_date=Helpers.getDateFormatForUTC(new Date().getTime())

    if(this.state.kitchen_staff){
        data.location_type="Kitchen"
    }else{
        data.location_type=this.state.workLocationType
       
    } 

    if(!this.state.kitchen_staff && this.state.attendanceDate!==Helpers.getDateFormatForUTC(new Date())){

       

        if(!Helpers.isItValidForMarkingAttendance(this.state.attendanceDate)){
                this.dialog.show({
                            title: "Error!!",
                            body: "You can mark attendance only for current attendance cycle",
                            actions: [
                                Dialog.OKAction(() => {
                                    let attendanceDate=Helpers.getDateFormatForUTC(new Date());
                                    this.setState({
                                        attendanceDate:attendanceDate
                                    });
                                })
                            ],
                        })

             return false
        }else if(this.state.attendanceDate>Helpers.getDateFormatForUTC(new Date())){
             this.dialog.show({
                            title: "Error!!",
                            body: "You can't mark attendance for future dates",
                            actions: [
                                Dialog.OKAction(() => {
                                    let attendanceDate=Helpers.getDateFormatForUTC(new Date());
                                    this.setState({
                                        attendanceDate:attendanceDate
                                    });
                                })
                            ],
                        })
             return false
        }

        data.attendance_date=this.state.attendanceDate;

         let reasonIdObject = this.mandateValidation("reasonId", Constants.FORM_SELECT)
        if (reasonIdObject.status) {
            data.reason_id = this.reasonIdComponent.value
        } else {

             this.props.dispatch(addEditAttendanceReady(true))
            return
        }

    
        let remarksObject = this.mandateValidation("remarks", Constants.FORM_INPUT)
        if (remarksObject.status) {
            data.remarks = this.remarksComponent.value
        } else {

             this.props.dispatch(addEditAttendanceReady(true))
            return
        }
    }   

    data.location_id=this.state.workLocationId


    let attendancesData=this.state.attendancesData


    let details=[]

    let eligibleToMark=false

        for (let i = 0 ;i< attendancesData.length ; i++) {
            if(attendancesData[i].attendance_flag){
                eligibleToMark=true

                if(((attendancesData[i].type==="" || attendancesData[i].type===undefined) && this.state.kitchen_staff) || (!this.state.kitchen_staff && attendancesData[i].checkbox && ((attendancesData[i].type==="" || attendancesData[i].type===undefined)) )){
                     this.dialog.show({
                            title: "Error!!",
                            body: "Please select attendance type for - "+attendancesData[i]['employee_name']+" - "+attendancesData[i]['employee_code'],
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    return
                }else{

                    if(!this.state.kitchen_staff && attendancesData[i].checkbox){
                        details.push({"employee_id":attendancesData[i].id,"type":attendancesData[i].type,"work_station":attendancesData[i].work_station})
                    }

                    if(this.state.kitchen_staff){
                        details.push({"employee_id":attendancesData[i].id,"type":attendancesData[i].type,"work_station":attendancesData[i].work_station})
                    }
                }

            }


        }

        if(!eligibleToMark){
             this.dialog.show({
                            title: "Error!!",
                            body: "Already marked the attendance for all employees for "+this.state.attendanceDate+" date. Thank you!!",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    return
        }

        if(details.length===0){
            this.dialog.show({
                            title: "Error!!",
                            body: "Pelase tick checkbox to mark attendance",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    return
        }

        data.details=details;
    let apiPayloadData=data;

this.props.dispatch(addEditAttendanceReady(false))
    if(this.state.editFlag){

        apiService.editAttendance(apiPayloadData,this.state.attendancesData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditAttendanceReady(true))
                        this.props.history.push("/dashboard/attendances/list")
                    } else {

                        this.props.dispatch(addEditAttendanceReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditAttendanceReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }else{

    apiService.addAttendance(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditAttendanceReady(true))
                        this.props.history.push("/dashboard/attendances/list")
                    } else {

                        this.props.dispatch(addEditAttendanceReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditAttendanceReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })


    }


}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

checkBoxChange = (id,e) => {

    let attendancesData = this.state.attendancesData;

    attendancesData.map(function(item, index) {
        if (item['id'] === id) {
            item.checkbox = e.target.checked
        }
        return true
    })

     this.setState({
        attendancesData: attendancesData
    });

}





attendanceTypeChange = (data,id) => {

         let attendancesData = this.state.attendancesData;

        attendancesData.map(function(item, index) {
            if (item['id'] === id) {
                if(data==="" || data===undefined || data.length===0){
                    item.type=""
                }else{
                    item.type = data.value
                }
            }
            return true
        })

         this.setState({
            attendancesData: attendancesData
        });
    }



    attendanceTypeChangeBulk = (data) => {
        
        let bulkTypeId=data.value

         let attendancesData = this.state.attendancesData;

        attendancesData.map(function(item, index) {
                if(item.attendance_flag){            
                  item.type = bulkTypeId
                }
            return true
        })

         this.setState({
            attendancesData: attendancesData,
            bulkTypeId:bulkTypeId
        });
    
    }

onCancelClick = () => {
    this.props.history.goBack()
}



getTeamAttendanceByWorkLocationId = () => {

    let attendancesDateCheck=true;
    if(this.state.kitchen_staff){
        attendancesDateCheck=false;
    }


    apiService.getTeamAttendanceByWorkLocationId(this.state.workLocationType,this.state.workLocationId,this.state.departmentId,attendancesDateCheck,this.state.attendanceDate)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {


                let array = filterUnwantedDataForCorp(responseData)

                let dataFound=false
                if(array.length>0){
                    dataFound=true
                }

                if (responseData && responseData.data) {                   
                    this.setState({
                        attendancesData: array,
                        attendancesDataFlag: dataFound,        
                    })                                

                }

            }

            this.props.dispatch(addEditAttendanceReady(true))


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditAttendanceReady(true))
        })
}


getTeamAttendanceByKitchenId = (id) => {
    let attendancesDateCheck=true;
    if(this.state.kitchen_staff){
        attendancesDateCheck=false;
    }

    apiService.getTeamAttendanceByKitchenId(id,attendancesDateCheck,this.state.attendanceDate)
        .then(responseData => {
            if (responseData.status === "SUCCESS") {


                let array = filterUnwantedData(responseData)

                let dataFound=false
                if(array.length>0){
                    dataFound=true
                }

                if (responseData && responseData.data) {                   
                    this.setState({
                        attendancesData: array,
                        attendancesDataFlag: dataFound,        
                    })                                

                }

            }

            this.props.dispatch(addEditAttendanceReady(true))


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditAttendanceReady(true))
        })
}



    workLocationTypeChange = (data) => {
    
        this.setState({
            workLocationType :data.value,
            workLocationId:"",            
            attendancesData:[],
            attendancesDataFlag:false,
            departmentId:"",
        })
    }

    workLocationChange = (data) => {
        
         this.setState({
            workLocationId :data.value,
            departmentId:"",            
            attendancesData:[],
            attendancesDataFlag:false
        })
            
    }

      reasonChange= (data) => {
    
        this.reasonIdComponent.value=data.value
    
        this.setState({
            reasonId :data.value,
            reasonIdErrorText: false,
            reasonIdErrorData: ''
        })
            
        this.reasonIdSection.className= this.reasonIdSection.className.replace(" has-error", "")
    }


     departmentChange = (data) => {
        
        this.setState({
            departmentId :data.value,
        },() => {

            if(data.value!=="" && data.value!==undefined){
                this.props.dispatch(addEditAttendanceReady(false))
                this.getTeamAttendanceByWorkLocationId()
            }else{
                this.setState({
                    attendancesData:[],
                    attendancesDataFlag:false
                });
            }

        })
            
    }



    



 cityChange = (data) => {
        this.setState({
            cityId :data.value,
            workLocationId:"",
            workLocationType:"",            
            attendancesData:[],
            attendancesDataFlag:false,
            departmentId:"",
        })
       
    }





 kitchenChange= (data) => {

        this.setState({
            workLocationId :data.value
        })
        

        if(data.value!=="" && data.value!==undefined){
            this.props.dispatch(addEditAttendanceReady(false))
            this.getTeamAttendanceByKitchenId(data.value)
        }else{
            this.setState({
                attendancesData:[],
                attendancesDataFlag:false
            });
        }
    }





    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <div className="row">
                    {this.createCustomToolBar()}
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                
                                <div className="box-header with-border">
                                    <div className="col-md-6">
                                        <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                    </div>

                                    {(() => {  if(this.state.attendancesDataFlag){ return (
                                    <div className="col-md-3">
                                        <p style={{float:"right",fontWeight: "800",marginTop: "2%",textTransform:"capitalize"}}>Bulk actions :</p>
                                    </div>
                                    )} })()}

                                    {(() => {  if(this.state.attendancesDataFlag){ return (
                                    <div className="col-md-3">
                                        <EntityType entityTypeChange={this.attendanceTypeChangeBulk} selectedValue={this.state.bulkTypeId} type="ATTENDANCE" />
                                    </div>
                                    )} })()}

                                 </div>

                                <div className="col-md-12 col-sm-12 col-xs-12"  style={{ marginBottom: '15px',background: "white",padding: "2% 0%" , height: this.state.tableHeight,overflowY: "auto",overflowX: "hidden",borderBottom:"1px solid #ddd"}}>

                                  {(() => {  

                                    if(!this.state.attendancesDataFlag && this.state.kitchen_staff){

                                   return (
                                        <div className="row" style={{textAlign:"center",padding:"4%",textTransform:"capitalize"}}>
                                            <h3>Please select kitchen to view employees!!</h3>
                                        </div>

                                     )
                               } else if(!this.state.attendancesDataFlag && !this.state.kitchen_staff){

                                return(
                                         <div className="row" style={{textAlign:"center",padding:"4%",textTransform:"capitalize"}}>
                                            <h3>Please select department/kitchen to view employees!!</h3>
                                        </div>
                                    )}

                               })()}

                                 {(() => {

                                       if(this.state.attendancesDataFlag){
                                                                        return (
                                <div className="col-md-10 col-sm-12 col-xs-12  col-md-offset-1">


                                 {(() => {

                                    if(!this.state.kitchen_staff && this.state.attendanceDate!==Helpers.getDateFormatForUTC(new Date())){
                                                                        return (
                                 <div className="col-md-12 col-sm-12 col-xs-12" style={{padding: "1% 0%"}}>

                                 <p>Since, you are adding previous day attendance. Please select reason and add remarks for the same.</p>
                                 <div className="col-md-12 col-sm-12 col-xs-12 reasonDrodown" style={{marginBottom:"1%"}}>
                                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                                <div className="form-group" ref={el =>
                                                                       this.reasonIdSection = el}>
                                                                       <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reason *</label>
                                                                       
                                                             <div className="col-sm-9" ref={el =>
                                                                      this.reasonIdComponent = el}>
                                                                      <Reasons type="ATTENDANCE" reasonChange={this.reasonChange} selectedValue={this.state.reasonId} />
                                                                      <span className="help-block" style={{ display: this.state.reasonIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                                      {this.state.reasonIdErrorData}
                                                                      </span>
                                                                    </div>
                                                                    </div>
                                                            </div>                                          
                                                    </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.remarksSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Remarks *</label>
                                                    <div className="col-sm-9">
                                                        <textarea className="form-control" placeholder="Enter Remarks" type="text" ref={el => this.remarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("remarks")}} />
                                                        <span className="help-block"style={{display: this.state.remarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.remarksErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                            </div>

                                             )}

                               })()}


                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>

                                        {(() => {

                                       if(!this.state.kitchen_staff){
                                        return (
                                            <th style={{background: "teal",color: "white",width: "10%"}}>Select</th>
                                            )
                                       }
                                   })()}
                                            
                                            <th style={{background: "teal",color: "white",width: "20%"}}>Employee Id</th>
                                            <th style={{background: "teal",color: "white",width: "20%"}}>Employee Name</th>
                                            <th style={{background: "teal",color: "white",width: "20%"}}>Contact No</th>
                                            <th style={{background: "teal",color: "white",width: "20%"}}>Type</th>
                                        </tr>
                                    </thead>
                                     {(() => {

                                       if(this.state.attendancesData.length>0){
                                                                        return (
                                        <tbody>
                                         {this.state.attendancesData.map((item, index) => (

                                            <tr>
                                             {(() => {

                                       if(!this.state.kitchen_staff){
                                        return (
                                                 <td>

                                                  {(() => {

                                                        if(item.attendance_flag){
                                                                        return (
                                                 <input className="checkbox" type="checkbox" name="checkbox" value="value" checked={item.checkbox} 
                                                        onChange={(e) => {
                                                            this.checkBoxChange(item.id,e)
                                                        }}
                                                        />
                                                        )
                                                    }

                                                    })()}


                                                        </td>
                                                         )
                                       }
                                   })()}
                                                <td>{item.employee_code}</td>
                                                <td>{item.employee_name}</td>
                                                <td>{item.employee_mobile}</td>

                                                 {(() => {

                                                        if(item.attendance_flag){
                                                                        return (

                                                <td><EntityType entityTypeChange={this.attendanceTypeChange} dataId={item.id} selectedValue={item.type} type="ATTENDANCE" /></td>
                                                                        )

                                                                    }else{
                                                                        return(
                                                                        <td>{item.entered_attendance_type}</td>
                                                                        )
                                                                    }

                                                                })()}

                                            </tr>

                                            ))}
                                        </tbody>

                                        )
                                        }

                                       })()}

                                </table>
                                </div>
                                )
                            }
                            })()}

                                </div>
                                

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>

                                        
                                         {(() => {
                                                if(this.state.editFlag){
                                                    return(

                                                    <button
                                                        className="btn btn-info pull-right"
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.onSaveClick()
                                                        }}>
                                                        Update Attendance
                                                    </button>

                                                    )
                                                }else if(this.state.attendancesDataFlag){
                                                     return(

                                                    <button
                                                        className="btn btn-info pull-right"
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.onSaveClick()
                                                        }}>
                                                        Mark Attendance
                                                    </button>

                                                    )
                                                }
                                             })()}
                                    </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        attendances: state.attendances,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditAttendance))


// WEBPACK FOOTER //
// ./src/modules/Attendance/Components/AddEditAttendance.js